// Central place for all Rallie brand + app screenshot asset URLs.
// These are the real assets uploaded by the customer.

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_app-showcase-360/artifacts/cpg4ws8y_1.webp",
  screenHomeSmall:
    "https://customer-assets.emergentagent.com/job_app-showcase-360/artifacts/c969056r_2.webp",
  screenHomeZoom:
    "https://customer-assets.emergentagent.com/job_app-showcase-360/artifacts/b1vug56w_3.webp",
  screenPodium:
    "https://customer-assets.emergentagent.com/job_app-showcase-360/artifacts/n5frd1um_4.webp",
  screenSignIn:
    "https://customer-assets.emergentagent.com/job_app-showcase-360/artifacts/md1l6tli_5.webp",
};
